import React from 'react';

const About = () => {
  const stats = [
    { number: '30+', label: 'Zrealizowanych Projektów' },
    { number: '10+', label: 'Zadowolonych Klientów' },
    { number: '5+', label: 'Lata Doświadczenia' }
  ];

  return (
    <section id="about" className="bg-gradient-primary">
      <div className="container">
        <h2 className="section-title">Kim jesteśmy?</h2>
        <div className="about-content">
          <p className="about-text">
            Mespi.dev zaczęło się od jednej osoby i projektów tworzonych z czystej pasji do technologii. Od 2018
            roku realizowaliśmy inicjatywy niekomercyjne, eksperymentowaliśmy i szlifowaliśmy kompetencje w
            realnych projektach.
          </p>
          <p className="about-text">
            Rosnące zainteresowanie naszym podejściem sprawiło, że naturalnym krokiem było sformalizowanie
            działalności i wejście na rynek komercyjny w 2024 roku. Dziś Mespi.dev to zespół specjalistów, który łączy solidne
            zaplecze techniczne z przemyślanym designem, pomagając firmom budować skalowalne i niezawodne
            rozwiązania cyfrowe.
          </p>
        </div>

        <div className="stats-grid max-w-1000 mx-auto">
          {stats.map((stat, index) => (
            <div key={index} className="stat-item">
              <div className="stat-number">{stat.number}</div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
